import React, { Component } from 'react';
import '../../App.css';
import '../../styles/app-demo.css';
import smartPhone from '../../assets/for-employees/iphone-x.png';
import Login from './login';
import Dashboard from './dashboard/dashboard';
import AppMenu from './app-menu';
import Transactions from './transactions';
import ManageCards from './manage-cards';
import AtmLocator from './atm-locator';
import BillPay from './BillPay/bill-pay';

class AppDemo extends Component {

  constructor(props){
    super(props)
    this.state = {
      userName: 'User',
      routeToDisplay: 'login',
      routedFrom: null,
      paymentList: [{
        name: 'City of Nashville TN',
        amount: '$1,500.00',
        date: new Date()
      }]
    }
    this.loginCallback = this.loginCallback.bind(this);
    this.toggleNewRoute = this.toggleNewRoute.bind(this);
    this.handleFooterRouting = this.handleFooterRouting.bind(this);
    this.updateBillPayList = this.updateBillPayList.bind(this);
  }

  componentDidMount() {
    window.scrollTo({
      top: 0,
      left: 0,
      behavior: 'smooth'
    });
  }

  loginCallback(name) {
    this.setState({
      userName: name,
      routeToDisplay: 'dashboard'
    })
  }

  toggleNewRoute(routeName, source) {
    if (source === 'menu') {
      this.setState({
        routedFrom: 'menu'
      })
    } else if (source === 'logout') {
      this.setState({
        routedFrom: 'login'
      })
    }
    this.setState({
      routeToDisplay: routeName
    })
  }


  handleFooterRouting(route) {
    this.props.handleFooterRouting(route);
    this.setState({
      routeToDisplay: route
    })
  }

  updateBillPayList(transaction) {
    let billPayListCopy = [...this.state.paymentList]
    billPayListCopy.push(transaction)
    this.setState({
      paymentList: billPayListCopy
    })
  }

  render() {

    return (
      <section className="fintwist-interactive-mobile-section">
       <div id="for-employees-section-4">
       <div className="section-title-text-wrapper">
                <p className="section-header">
                  Try our Fintwist Mobile App
                </p>
                <p>
                Look around and see how we can manage your money, keep you safe and help you pay your bills online. Enter your name and log in.
                </p>
              </div></div>
        <div className="fintwist-interactive-mobile">
          
          <img className="phone-image" src={smartPhone} alt={''} />
          {
            this.state.routeToDisplay === 'login' ?
            <Login toggleNewRoute={this.toggleNewRoute} loginCallback={this.loginCallback} />
            :
            null
          }
          {
            this.state.routeToDisplay === 'dashboard' ?
            <Dashboard toggleNewRoute={this.toggleNewRoute} {...this.state} />
            :
            null
          }
          {
            this.state.routeToDisplay === 'transactions' ?
            <Transactions toggleNewRoute={this.toggleNewRoute} {...this.state} />
            :
            null
          }
          {
            this.state.routeToDisplay === 'card management' ?
            <ManageCards toggleNewRoute={this.toggleNewRoute} {...this.state} />
            :
            null
          }
          {
            this.state.routeToDisplay === 'atm locator' ?
            <AtmLocator toggleNewRoute={this.toggleNewRoute} {...this.state} />
            :
            null
          }
          {
            this.state.routeToDisplay === 'menu' ?
            <AppMenu toggleNewRoute={this.toggleNewRoute} {...this.state} />
            :
            null
          }
          {
            this.state.routeToDisplay === 'bill pay' ?
            <BillPay updateBillPayList={this.updateBillPayList} toggleNewRoute={this.toggleNewRoute} {...this.state} />
            :
            null
          }
        </div>
      </section>
    );
  }
}

export default AppDemo;
